












































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import {calc_day_night_hours, DEFAULT_DAY_BEGINTIME, DEFAULT_DAY_ENDTIME, new_curdatetime, copy_datetime, round_euro} from '@/claesutils';
import { api } from '@/api';
function findOption(records, value): object|null {
  let result = null;
  if (records) {
    records.forEach(option => {
      if (option.value === value) {
        result = option;
      }
    });
  }
  return result;
  }
enum ProjectPriceType {
  hourrate = 1,
  fixed,
  special
}
@Component
export default class JobsDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public items: object[] = [];
  public recProjectJob: object = {};
  public canEditProjectAmount = false;
  public indexProjectJob = -1;
  public dialogProjectJob = false;
  public dialogDeleteProjectJob = false;
  public recJobRest: object = {};
  public indexJobRest = -1;
  public dialogJobRest = false;
  public dialogDeleteJobRest = false;

  public loadedRecord(rec) {
    this.sumRestHours(rec);
  }

  public newRecord(rec) {
    rec.begin_timestamp = rec.end_timestamp = new_curdatetime();
    this.sumRestHours(rec);
  }

  public copyRecord(rec) {
    rec.sale_id = null;
    rec.is_first_job = rec.is_escort_checked = false;
    rec.invoice_base_amount = 0;
    rec.charter_amount = 0;
    rec.km_tax_amount = 0;
    rec.km_tax_invoiceamount = 0;
    // rec.invoice_vatrate = 0;
    rec.invoice_vat = 0;
    rec.invoice_amount = 0;
    rec.customer_begin_timestamp = null;
    rec.begin_timestamp = rec.end_timestamp = copy_datetime(rec.begin_timestamp);
    rec.hours_worked_day = rec.hours_worked_night = rec.hours_worked_total = 0;
    rec.hours_compensation_day = rec.hours_compensation_night = rec.hours_compensation_total = 0;
    rec.hours_overlap_day = rec.hours_overlap_night = rec.hours_overlap_total = 0;
    rec.projectjobs = [];
    this.sumRestHours(rec);
    // rec.cmr = null;
  }
  public isProjectJob() {
    const ref: any = this.$refs.customer;
    if (ref) {
      const option = ref.findOptionRec();
      console.log('checkIsProjectJob0', option);
      return true;
    } else {
      console.log('checkIsProjectJob0');
      return true;
    }
  }

  public allowNewProjectJob(props) {
    if (!props.isReadOnly) {
      const ref: any = this.$refs.layout;
      const jobrec = ref.rec;
      return jobrec.customer_id && jobrec.truck_id;
    } else {
      return false;
    }
  }
  public async newProjectJob() {
    const form: any = this.$refs.formProjectJob;
    if (form) {
      form.resetValidation();
    }
    const ref: any = this.$refs.layout;
    const jobrec = ref.rec;
    console.log(jobrec);
    const rec: any = {};
    rec.projectnr = '';
    rec.cmr = '';
    rec.loading_location = '';
    rec.unloading_location = '';
    rec.begin_timestamp = jobrec.begin_timestamp;
    rec.end_timestamp = jobrec.end_timestamp;
    rec.diesel_surcharge_percentage = 0;
    rec.km_tax_invoice_amount = 0;
    rec.projectprice_id = 1;
    rec.hours = 0;
    rec.amount_hours = 0;
    rec.amount_excl = 0;
    rec.amount_vat = 0;
    rec.amount_incl = 0;
    await this.get_project_price_details(jobrec, rec);
    this.calc_and_update_projectprice(rec);
    this.recProjectJob = {...rec};
    this.indexProjectJob = -1;
    this.dialogProjectJob = true;
  }
  public update_project_hours(rec) {
    const result = calc_day_night_hours(rec.begin_timestamp, rec.end_timestamp, DEFAULT_DAY_BEGINTIME, DEFAULT_DAY_ENDTIME);
    rec.hours = result.total;
  }
  public project_times_changed(rec) {
    // console.log('project_times_changed', rec);
    if (rec && rec.begin_timestamp && rec.end_timestamp) {
      this.update_project_hours(rec);
      this.calc_and_update_projectprice(rec);
    }
  }
  public project_hourrate_changed(rec) {
    this.calc_and_update_projectprice(rec);
  }
  public update_project_diesel_surcharge(rec) {
    // console.log('update_project_diesel_surcharge');
    this.calc_and_update_projectprice(rec);
  }
  public update_project_km_tax_invoiceamount(rec) {
    // console.log('update_project_km_tax_invoiceamount');
    this.calc_and_update_projectprice(rec);
  }
  public update_project_amount_hours(rec) {
    this.calc_and_update_projectprice(rec);
  }
  public async projectprice_id_updated(rec) {
    // console.log('projectprice_id_updated');
    const ref: any = this.$refs.layout;
    const jobrec = ref.rec;
    this.update_project_hours(rec);
    await this.get_project_price_details(jobrec, rec);
    this.calc_and_update_projectprice(rec);
  }
  public async get_project_price_details(jobrec, rec) {
    console.log('get_project_price_details');
    const data = {
      customer_id: jobrec.customer_id,
      truck_id: jobrec.truck_id,
      projectprice_id: rec.projectprice_id
    };
    const response = await this.api.postAction(this.$store, this.apiUrl + 'calcprojectprice', data);
    console.log('get_project_price_details', response);
    if (response) {
      const resp: any = response.data;
      // console.log(resp);
      rec.projectprice_id = resp.projectprice_id;
      rec.vatrate = resp.vatrate;
      // rec.projectpricetype_id = resp.projectpricetype_id;
      this.$set(rec, 'projectpricetype_id', resp.projectpricetype_id);
      this.canEditProjectAmount = rec.projectpricetype_id === ProjectPriceType.special;
      rec.projectprice_rate = resp.projectprice_rate;
      if (rec.projectpricetype_id === ProjectPriceType.hourrate) {
        rec.hourrate = rec.projectprice_rate;
      } else if (rec.projectpricetype_id === ProjectPriceType.fixed) {
         rec.hourrate = 0;
      } else if (rec.projectpricetype_id === ProjectPriceType.special) {
        rec.hourrate = 0;
      }
      rec.diesel_surcharge_percentage = resp.diesel_surcharge_percentage;
    }
  }
  public calc_and_update_projectprice(rec) {
    console.log('calc_and_update_projectprice', rec.projectpricetype_id, rec.amount_hours);
    {
      if (rec.projectpricetype_id === ProjectPriceType.hourrate) {
        rec.amount_hours = round_euro(rec.hours * rec.hourrate);
      } else if (rec.projectpricetype_id === ProjectPriceType.fixed) {
         rec.amount_hours = rec.projectprice_rate;
      } else if (rec.projectpricetype_id === ProjectPriceType.special) {
      }
    }
    const dieselsurcharge = round_euro(rec.amount_hours * rec.diesel_surcharge_percentage / 100);
    rec.amount_excl = rec.amount_hours + dieselsurcharge + rec.km_tax_invoice_amount;
    rec.amount_vat = round_euro(rec.amount_excl * rec.vatrate / 100);
    rec.amount_incl = rec.amount_excl + rec.amount_vat;
  }
  public async setProjectJob() {
    const form: any = this.$refs.formProjectJob;
    if (form.validate()) {
      const ref: any = this.$refs.layout;
      const jobrec = ref.rec;
      const rec = this.recProjectJob as any;
      if (this.indexProjectJob === -1) {
        rec.sequencenr = ref.rec.projectjobs.length + 1;
        ref.rec.projectjobs.push({...rec});
      } else {
        ref.rec.projectjobs[this.indexProjectJob] = {...rec};
        this.indexProjectJob = -1;
      }
      this.dialogProjectJob = false;
    }
  }
  public async editProjectJobItem(item) {
    const ref: any = this.$refs.layout;
    this.indexProjectJob = ref.rec.projectjobs.indexOf(item);
    this.recProjectJob = {...item};
    const jobrec = ref.rec;
    // await this.get_project_price_details(jobrec, this.recProjectJob);
    this.calc_and_update_projectprice(this.recProjectJob);
    this.dialogProjectJob = true;
  }
  public deleteProjectJobItem(item) {
    const ref: any = this.$refs.layout;
    this.indexProjectJob = ref.rec.projectjobs.indexOf(item);
    this.dialogDeleteProjectJob = true;
  }
  public executeDeleteProjectJob() {
    const ref: any = this.$refs.layout;
    ref.rec.projectjobs.splice(this.indexProjectJob, 1);
  }
  public sumRestHours(rec) {
    rec.hours_rest_day = rec.rests.reduce((acc, rest) => acc + rest.day_hours, 0);
    rec.hours_rest_night = rec.rests.reduce((acc, rest) => acc + rest.night_hours, 0);
    rec.hours_rest_total = rec.rests.reduce((acc, rest) => acc + rest.total_hours, 0);
    this.sumNetHours(rec);
  }
  public sumNetHours(rec) {
    rec.hours_customer_day = rec.hours_worked_day - rec.hours_rest_day;
    rec.hours_customer_night = rec.hours_worked_night - rec.hours_rest_night;
    rec.hours_customer_total = rec.hours_worked_total - rec.hours_rest_total;

    rec.hours_driver_day = rec.hours_worked_day - rec.hours_rest_day - rec.hours_compensation_day - rec.hours_overlap_day;
    rec.hours_driver_night = rec.hours_worked_night - rec.hours_rest_night - rec.hours_compensation_night - rec.hours_overlap_night;
    rec.hours_driver_total = rec.hours_worked_total - rec.hours_rest_total - rec.hours_compensation_total - rec.hours_overlap_total;
  }

  public newJobRest() {
    const form: any = this.$refs.formJobRest;
    if (form) {
      form.resetValidation();
    }
    const rec = this.recJobRest as any;
    rec.begin_rest = rec.end_rest = new_curdatetime();
    rec.projectprice_id = 1;
    this.indexJobRest = -1;
    this.dialogJobRest = true;
  }
  public async setJobRest() {
    const form: any = this.$refs.formJobRest;
    if (form.validate()) {
      const rec = this.recJobRest as any;
      const result = calc_day_night_hours(rec.begin_rest, rec.end_rest, DEFAULT_DAY_BEGINTIME, DEFAULT_DAY_ENDTIME);
      // console.log(result);
      rec.day_hours = result.day;
      rec.night_hours = result.night;
      rec.total_hours = result.total;
      const ref: any = this.$refs.layout;
      if (this.indexJobRest === -1) {
        rec.sequencenr = ref.rec.rests.length + 1;
        ref.rec.rests.push({...rec});
      } else {
        ref.rec.rests[this.indexJobRest] = {...rec};
        this.indexJobRest = -1;
      }
      this.sumRestHours(ref.rec);
      this.dialogJobRest = false;
    }
  }

  public editJobRestItem(item) {
    const ref: any = this.$refs.layout;
    this.indexProjectJob = ref.rec.rests.indexOf(item);
    this.recJobRest = {...item};
    this.dialogJobRest = true;
  }
  public deleteJobRestItem(item) {
    const ref: any = this.$refs.layout;
    this.indexJobRest = ref.rec.rests.indexOf(item);
    this.dialogDeleteJobRest = true;
  }
  public executeDeleteJobRest() {
    const ref: any = this.$refs.layout;
    ref.rec.rests.splice(this.indexJobRest, 1);
  }

  public hours_worked_changed(rec) {
    // console.log('hours_worked_changed', rec);
    if (rec) {
      rec.hours_worked_total = rec.hours_worked_day + rec.hours_worked_night;
      this.sumNetHours(rec);
    }
  }

  public hours_compensation_changed(rec) {
    console.log('hours_compensation_changed', rec);
    if (rec) {
      rec.hours_compensation_total = rec.hours_compensation_day + rec.hours_compensation_night;
      this.sumNetHours(rec);
    }
  }

  public hours_overlap_changed(rec) {
    console.log('hours_overlap_changed', rec);
    if (rec) {
      rec.hours_overlap_total = rec.hours_overlap_day + rec.hours_overlap_night;
    }
  }

  public times_changed(rec) {
    console.log('times_changed', rec);
    if (rec && rec.begin_timestamp && rec.end_timestamp) {
      const result = calc_day_night_hours(rec.begin_timestamp, rec.end_timestamp, DEFAULT_DAY_BEGINTIME, DEFAULT_DAY_ENDTIME);
      // console.log(result);
      rec.hours_worked_day = result.day;
      rec.hours_worked_night = result.night;
      rec.hours_worked_total = result.total;
      this.sumNetHours(rec);
    }
  }
  public update_surcharge(rec) {
    this.update_invoice_amount(rec);
  }
  public update_diesel_surcharge(rec) {
    this.update_invoice_amount(rec);
  }
  public update_vatrate(rec) {
    this.update_invoice_amount(rec);
  }
  public update_km_tax_invoiceamount(rec) {
    rec.km_tax_invoiceamount = rec.is_km_tax_tobeinvoiced ? rec.km_tax_amount : 0;
    this.update_invoice_amount(rec);
  }


  public update_invoice_amount(rec) {
    // console.log('update_invoice_amount', rec);
    const surcharge = round_euro(rec.invoice_base_amount * rec.surcharge_percentage / 100);
    const dieselsurcharge = round_euro(rec.invoice_base_amount * rec.diesel_surcharge_percentage / 100);

    rec.invoice_amount = rec.invoice_base_amount + rec.charter_amount + surcharge + dieselsurcharge + rec.km_tax_invoiceamount;
    rec.invoice_vat = rec.invoice_amount * rec.invoice_vatrate / 100;
    // console.log('invoice_vat', rec.invoice_vat);
  }
  public async calculateTotals(rec) {
    if (rec.customer_id) {
      // console.log(rec.hours_worked_total, rec.hours_customer_total);
      const data = {
        customer_id: rec.customer_id,
        km_total: rec.km_empty_back - rec.km_empty_towards,
        hours_worked_total: rec.hours_customer_total,
        load_destination: rec.load_destination,
        unload_destination: rec.unload_destination,
        load_info: rec.load_info
      };
      const response = await this.api.postAction(this.$store, this.apiUrl + 'calcbaseamount', data);
      if (response) {
        const respdata: any = response.data;
        console.log(respdata);
        this.$set(rec, 'invoice_base_amount', respdata.invoice_base_amount);
        // this.$set(rec, 'charter_amount', respdata.charter_amount);
        this.$set(rec, 'invoice_vatrate', respdata.invoice_vatrate);
        this.$set(rec, 'diesel_surcharge_percentage', respdata.diesel_surcharge_percentage);
        this.update_invoice_amount(rec);
      }
    }
  }

  public async changeVehicle(rec) {
    const response = await this.api.getRecord(this.$store, '/vehicles/' + rec.truck_id);
    if (response) {
      const resp: any = response.data;
      console.log(resp);
      if (resp.driver_id) {
        this.$set(rec, 'driver_id', resp.driver_id);
      }
      if (resp.load_destination) {
        this.$set(rec, 'load_destination', resp.load_destination ? resp.load_destination : '');
      }
      if (resp.unload_destination) {
        this.$set(rec, 'unload_destination', resp.unload_destination ? resp.unload_destination : '');
      }
      // if (!rec.company_id) {
      this.$set(rec, 'company_id', resp.is_pilot ? 2 : 3);
      // }
    }
  }

  public async changeCustomer(rec) {
    this.calculateTotals(rec);
  }



}
